import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "panel"
}

import { onMounted, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { CmsPage, useCmsPage, cmsPageUserTypes } from '../CmsPage';
import { ErrorBag, handleFormError } from '@/core/common';
import { fillContentModels } from '@/core/languageContent';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import PageLayout from '@/core/components/PageLayout.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppCheck from '@/core/components/form/AppCheck.vue';
import AppEditor from '@/core/components/editor/AppEditor.vue';
import { getAllLanguages, Language } from '@/modules/parameters/Language';

interface CmsPageFormProps {
	pageTitle: string;
	cmsPage: CmsPage;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CmsPageForm',
  props: {
    pageTitle: {},
    cmsPage: {}
  },
  emits: [
	'cancel',
	'saved',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { $gettext } = useGettext();
const resource = useCmsPage();
const languages = ref<Language[]>([]);
const errors = ref<ErrorBag>({});
const data = ref<Partial<CmsPage>>();

// Set data to form on mount and when the prop value changes.
const setData = () => {
	data.value = Object.assign({content: []}, props.cmsPage);
	data.value.content = fillContentModels(data.value.content || [], languages.value, {
		headline: '',
		text: '',
	});
};
onMounted(async () => {
	languages.value = await getAllLanguages();
	setData();
});
watch(() => props.cmsPage, setData);

const save = async () => {
	errors.value = {};

	const postBody: CmsPage = Object.assign({}, data.value) as CmsPage;

	let promise: Promise<CmsPage>;
	if (props.cmsPage?.id) {
		promise = resource.put(props.cmsPage.id, postBody);
	} else {
		promise = resource.post(postBody);
	}

	try {
		const response = await promise;

		emit('saved', response);

	} catch (e) {
		return handleFormError(e as Error, errors);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": __props.pageTitle,
    "base-tag": "form",
    onSubmit: _withModifiers(save, ["prevent"])
  }, {
    "header-actions": _withCtx(() => [
      _createVNode(AppButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Avbryt", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AppButton, { type: "submit" }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Spara", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (data.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Inställningar", -1)
            ]))])), [
              [_directive_translate]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(cmsPageUserTypes)), ([userType, name]) => {
              return (_openBlock(), _createBlock(AppFormGroup, {
                key: userType,
                id: `cms_page_user_type_${userType}`,
                errors: errors.value.user_type,
                label: name
              }, {
                before: _withCtx(() => [
                  _createVNode(AppCheck, {
                    id: `cms_page_user_type_${userType}`,
                    modelValue: data.value.user_type,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.user_type) = $event)),
                    value: userType
                  }, null, 8, ["id", "modelValue", "value"])
                ]),
                _: 2
              }, 1032, ["id", "errors", "label"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
        return (_openBlock(), _createElementBlock("div", {
          key: language.id,
          class: "panel"
        }, [
          _createElementVNode("h2", null, _toDisplayString(language.name), 1),
          _createVNode(AppFormGroup, {
            id: `cms_page_headline_${language.id}`,
            errors: errors.value.headline,
            label: _unref($gettext)('Rubrik')
          }, {
            default: _withCtx(() => [
              _createVNode(AppInput, {
                id: `cms_page_headline_${language.id}`,
                modelValue: data.value.content[language.id].headline,
                "onUpdate:modelValue": ($event: any) => ((data.value.content[language.id].headline) = $event),
                required: ""
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["id", "errors", "label"]),
          _createVNode(AppEditor, {
            modelValue: data.value.content[language.id].text,
            "onUpdate:modelValue": ($event: any) => ((data.value.content[language.id].text) = $event),
            errors: errors.value.text,
            label: _unref($gettext)('Text')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "label"])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})